import React from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import BoundaryNode from './BoundaryNode'

const BoundaryList = ({ selectionStore, root, parentNode, savingBoundaries, t }) => {
  if (parentNode.boundaries.length === 0) {
    return parentNode.loaded === true
      ? null
      : (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px', color: '#64748B' }}>
          <div className='spinner' style={{ width: 14, height: 14 }} />
        </div>
        )
  }

  const allChildrenSelected =
    parentNode.boundaries.length > 0 &&
    parentNode.boundaries.every(b =>
      (selectionStore.item.selectedBoundaries || []).some(sb => sb.remote_db_id === b.id)
    )

  return (
    <ul className='boundary-tree-list'>
      {parentNode.expanded && (
        <li
          className='boundary-tree-select-all'
          onClick={() => {
            if (!selectionStore.item || typeof selectionStore.item.addBoundariesToSelection !== 'function') return
            if (allChildrenSelected) {
              selectionStore.item.removeBoundariesFromSelection(parentNode.boundaries)
            } else {
              selectionStore.item.addBoundariesToSelection(parentNode.boundaries, selectionStore.data.group.pk)
            }
          }}
        >
          <input
            type='checkbox'
            className='boundary-tree-checkbox'
            checked={allChildrenSelected}
            onChange={(event) => {
              event.stopPropagation()
              if (!selectionStore.item || typeof selectionStore.item.addBoundariesToSelection !== 'function') return
              if (event.currentTarget.checked) {
                selectionStore.item.addBoundariesToSelection(parentNode.boundaries, selectionStore.data.group.pk)
              } else {
                selectionStore.item.removeBoundariesFromSelection(parentNode.boundaries)
              }
            }}
          />
          <span>{t('GLOBAL.SELECT_ALL', { defaultValue: 'Select all' })}</span>
        </li>
      )}
      {parentNode.boundaries.map(boundary => (
        <BoundaryNode
          key={boundary.id}
          savingBoundaries={savingBoundaries}
          root={root}
          boundary={boundary}
        />
      ))}
    </ul>
  )
}

export default withTranslation()(inject('selectionStore')(observer(BoundaryList)))
